module.exports = {
  permission: {
    permission_RealMap: "Real time graph",
    permission_TileMap: "Pollution cloud image",
    permission_RoadStatistics: "道路统计",
    permission_FaultIden: "故障自动识别报警",
    permission_FaultAbnormal: "故障自动识别报警",
    permission_PollutionAlarm: "自动污染报警",
    permission_DataAnalysis: "设备质控",
    permission_StationManage: "基础信息",
    permission_DataDownload: "数据下载",
    permission_CaliSetting: "校准设置",
    permission_HourStatistics: "时段统计",
    permission_RoadAss: "污染自动拍照",
    permission_StationStatistics: "设备数据统计",
    permission_RoadInterLayer: "道路插值图",
    permission_ReportManage: "报表管理",
    permission_HistoryMap: "历史轨迹",
    permission_RoadTileLayer: "道路云图",
    permission_Panorama: "道路全景",
    permission_TaskList: "任务列表",
    permission_TaskStat: "仪表盘"
  },
  message: {
    label_vehicle_monitor: " Vehicle air quality monitoring system",
    label_login: "Sign in",
    label_username: "User name",
    label_password: "Password",
    label_keep_signed_in: "Keep me signed in",
    label_login: "Sign in",
    label_logged_successfully: "logged in successfully",
    label_logged_failed: "logged in failed",
    label_London_vehicle: "label_London_vehicle",
    label_sign_out: "Sign Out",
    label_update_key: "Update Key",
    label_project_config: "Project Config",
    label_update_password: "Update Password",

    label_standard: "Standard station",
    label_display_standard_name: "Name of Standard Station",
    label_pollution_cloud_image: "Pollution cloud image",
    label_standard_color: "Standard color",
    label_enhanced_color: "Enhanced color",
    label_plate_number: "Plate number",
    label_alarm_pictures: "Alarm pictures",
    label_online_quantity: "Online quantity",
    label_today_onlie_rate: "Online Today",
    label_total: "Total",
    label_average_PM25: "Average PM₂.₅",
    label_average_PM10: "Average PM₁₀",
    label_No: "No",
    label_plate_number: "Plate number",
    label_SN: "SN",
    label_PM25: "PM₂.₅",
    label_PM10: "PM₁₀",
    label_time_update: "Time updates to",
    label_speed: "Speed",
    label_single_device_display: "Single Device Display",
    label_view_video: "View video",
    label_online_rate: "Online rate",
    //污染云图
    label_point_filtering: "Point filtering",
    label_pollution_point: "Pollution point",
    label_comparison_standard: "Comparison of standard stations",
    label_district_county_ranking: "District and county ranking",
    label_street_town_ranking: "Street Town ranking",
    label_custom_area: "Custom Area",
    label_clean_ranking: "Clean ranking",
    label_pollution_ranking: "Pollution ranking",
    label_display_pollution_point: "Display Pollution point",
    label_road: "Road",
    label_district_county: "District and county",
    label_street_town: "Street Town",
    label_location: "Location",
    label_number_of_points: "Number of points",
    label_refresh: "Refresh",
    label_export: "Export",
    label_name: "Name",
    label_grade: "Grade",
    label_surrounding_PM10: "Surrounding PM10",
    label_surrounding_PM25: "Surrounding PM2.5",
    label_number_of_points: "Number of points",
    label_country: "Country",
    label_province: "Province",
    label_city: "City",
    label_district: "District",
    label_street_town: "Street Town",
    label_improvement_PM10: "Improvement rate of PM10",
    label_improvement_PM25: "Improvement rate of PM2.5",
    label_filter_size: "Filter size",
    label_number_of_points_region: "Number of points in a region",
    label_point_spacing: "Point spacing (m)",
    label_selection_area: "Selection area",
    label_filtering: "Filtering",
    label_get_rid_unknown_road: "Get rid of the unknown road",
    label_pollution_point_name: "Name of pollution point",
    label_operate: "Operate",
    label_display: "Display",
    label_hide: "Hide",
    label_location_data: "Location data",
    label_number_of_vehicles: "Number of vehicles",
    label_average_number_of_vehicles: "Average number of vehicles per day",
    label_print_chart: "Print chart",
    label_download_PNG: "Download PNG files",
    label_download_JPEG: "Download JPEG files",
    label_download_PDF: "Download PDF files",
    label_download_SVG: "Download SVG files",
    label_download_CSV: "Download CSV files",
    label_download_XLS: "Download XLS files",
    label_view_data_tables: "View data tables",
    label_menu: "MENU"
  },
  placeholder: {
    label_search: "Search for vehicles or equipment",
    label_type_of_standard_station: "Selecting the Type of Standard Station"
  },
  brands: {
    nike: "耐克",
    adi: "阿迪达斯",
    nb: "新百伦",
    ln: "李宁"
  }
};
